import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/siteData';
import SectionHeading from '@/components/feature/SectionHeading';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-16" aria-labelledby="category-title">
      <SectionHeading
        eyebrow="话题分类"
        title="你想吃的瓜，都分好了类"
        description="按话题归类，快速找到你关心的那一条线，不用在信息流里反复翻找。"
      />
      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {categories.map((cat) => {
          const count = articles.filter((a) => a.category === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 line-clamp-3 font-body text-sm leading-relaxed text-foreground-600">
                {cat.description}
              </p>
              <span className="mt-4 flex items-center gap-1 font-label text-xs text-foreground-500">
                {count} 篇整理
                <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}